import { defineStore } from 'pinia'

export const useSearchStore = defineStore('search', {
  state: () => ({
    isOvernight: false,
    results: [],
    sortBy: 'recommended',
    availableOnly: false,
    nearMe: false,
  }),
  actions: {
    setSortBy(sortBy) {
      this.sortBy = sortBy;
    },
    setAvailableOnly(availableOnly) {
      this.availableOnly = availableOnly;
    },
    setNearMe(nearMe) {
      this.nearMe = nearMe;
    },
    setIsOvernight(isOvernight) {
      this.isOvernight = isOvernight;
    },
    setResults(results) {
      this.results = results;
    },
    clearOvernight() {
      this.isOvernight = false;
    }
  },
  getters: {
    overnight: (state) => state.isOvernight,
  },
  persist: {
    storage: piniaPluginPersistedstate.sessionStorage(),
  },
});
